import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c90feac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "library-header" }

import { useRouter } from 'vue-router'
import AppMenuItem from '@/app/components/header/AppMenuItem.vue'
import { computed } from 'vue'

type MenuItem = {
  text: string
  link: string
  icon: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LibraryHeader',
  setup(__props) {

const router = useRouter()
const routeName = computed(() => router.currentRoute.value.name)

const menuItems: MenuItem[] = [
  {
    text: 'Books',
    link: 'my_library.books',
    icon: 'ibook',
  },
  {
    text: 'Articles',
    link: 'my_library.articles',
    icon: 'iarticles',
  },
  {
    text: 'Podcasts',
    link: 'my_library.episodes',
    icon: 'ipodcasts',
  },
  {
    text: 'Lists',
    link: 'my_library.custom_lists',
    icon: 'iflag',
  },
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, (menuItem) => {
      return _createVNode(AppMenuItem, {
        key: menuItem.link,
        icon: menuItem.icon,
        link: menuItem.link,
        text: menuItem.text,
        isActive: _unref(routeName) === menuItem.link,
        stackOnMobile: false,
        class: _normalizeClass({
        'library-header__item': true,
        'library-header__item--active': _unref(routeName) === menuItem.link,
      })
      }, null, 8, ["icon", "link", "text", "isActive", "class"])
    }), 64))
  ]))
}
}

})